import apiClient from "../model/requestUtils";
import type { Token } from "../model/shared";
import { ENDPOINTS } from "../model/authEndpoints";

export async function checkAuthentication(token: string): Promise<boolean> {
  try {
    // Effectuez une requête HTTP vers votre backend pour valider le token
    const response = await apiClient.get<Token>(ENDPOINTS.verifyToken(token));

    if (response.status === 200) {
      return true;
    } else {
      return false;
    }
  } catch (error) {
    console.error("Error verifying authentication:", error);
    return false;
  }
}

export function isTokenValid(token: string | null): boolean {
  if (!token) return false;
  try {
    const payload = JSON.parse(atob(token.split(".")[1]));
    return payload.exp * 1000 > Date.now();
  } catch {
    return false;
  }
}
